import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'

export interface RouterContext {
  queryClient: QueryClient
}

/**
 * Les composants « introuvable », « erreur » et « chargement » sont déclarés
 * une seule fois sur le routeur (`src/main.tsx`) et héritent jusqu'ici.
 */
export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
})

function RootComponent() {
  return <Outlet />
}
